import { ImportError } from './ImportError'

/**
 * Error that is thrown when a import value is required.
 */
export class ImportInvalidValueError extends ImportError {
  constructor(message: string) {
    super(message)
    this.name = 'ImportInvalidValueError'
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
